// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --vehicles` replaces `routes.ts` with `modules/routes.vehicles.ts`.
// The list of file replacements can be found in `angular.json`.
import { Routes } from '@angular/router';

import { dorRoutes } from '../dealer-onboarding/dealer-onboarding.routes';
import { sellRoutes } from '../sell/sell.routes';
import { ambassadorRoutes } from '../ambassador/ambassador.routes';
import {
  ambassadorAuthorizationRoutes
} from '../ambassador-authorization/ambassador-authorization.routes';
import { profileManagementRoutes } from '../profile-management/profile-management.routes';
import { registrationRoutes } from '../app/modules/registration/registration.routes';
import { searchRoutes } from '../search/search.routes';
import { supportPageRoutes } from '../app/modules/supportpage/supportpage.routes';
import {
  sellingDisclosureRoutes
} from '../app/modules/sellingdisclosures/sellingdisclosures.routes';
import {
  summaryDisclosuresRoutes
} from '../app/modules/summarydisclosures/summarydisclosures.routes';
import { vehiclesRoutes } from '../vehicles/vehicles.routes';
import { transportationHubRoutes } from '../transportation/transportation-hub.routes';
import { offerListRoutes } from '../offer-list/offer-list.routes';
import { auctionSummaryRoutes } from '../auction-summary/auction-summary.routes';
import { termsConditionsRoutes } from '../terms-conditions/terms-conditions.routes';
import { messagesRoutes } from '../messages/messages.routes';
import { dashboardRoutes } from '../dashboard/dashboard.routes';
import { unsubscribeRoutes } from '../unsubscribe/unsubscribe.routes';
import { reactSpikeRoutes } from '../react-spike/react-spike.routes';

export const DEFAULT_ROUTES: Routes = [
  ...searchRoutes,
  ...dorRoutes,
  ...sellRoutes,
  ...ambassadorRoutes,
  ...ambassadorAuthorizationRoutes,
  ...profileManagementRoutes,
  ...registrationRoutes,
  ...supportPageRoutes,
  ...sellingDisclosureRoutes,
  ...summaryDisclosuresRoutes,
  ...vehiclesRoutes,
  ...transportationHubRoutes,
  ...offerListRoutes,
  ...auctionSummaryRoutes,
  ...termsConditionsRoutes,
  ...messagesRoutes,
  ...dashboardRoutes,
  ...unsubscribeRoutes,
  ...reactSpikeRoutes
];
